<button
  class="notice"
  type="button"
  (click)="noticeClick.emit()"
>
  <span>{{ labelKey() | translate }}</span>
  <ion-icon
    slot="start"
    aria-hidden="true"
    src="../assets/material-symbols/notification_important_24dp.svg"
  ></ion-icon>
</button>
